import { NEARMECHECK_ROUTES } from 'src/routes';

import { isInDevelopmentEnv } from './environment-utils';

// Widget routes always start with `#/` (e.g. `#/gmb/select-location?accountToken=xxx`),
// which distinguishes them from the host page's own anchors (e.g. `#faq`).
const WIDGET_ROUTE_HASH_PREFIX = '#/';

function getWidgetRouteInUrlHash(): string | null {
    const { hash } = window.location;

    return hash.startsWith(WIDGET_ROUTE_HASH_PREFIX) ? hash.slice(1) : null;
}

// The Google OAuth callback redirects back to the host page with the widget route
// (including the accountToken) inside the hash fragment. MemoryRouter never reads
// window.location, so its initial entry has to be seeded from the hash once at boot.
export function getInitialWidgetRoute(): string {
    return getWidgetRouteInUrlHash() ?? NEARMECHECK_ROUTES.START;
}

// Removes the widget route (and the accountToken inside it) from the address bar and
// browser history. Host-page anchors don't match the widget prefix and are left
// untouched, so the host URL is never modified outside the OAuth return (ACMO-41).
export function scrubWidgetRouteFromUrl(): void {
    if (getWidgetRouteInUrlHash() === null) {
        return;
    }

    // Keep the route and accountToken in the URL in development to preserve them during
    // website reloads while iterating on the source code (same as AuthorizationProvider).
    if (isInDevelopmentEnv) {
        return;
    }

    window.history.replaceState(
        window.history.state,
        '',
        window.location.pathname + window.location.search
    );
}
